import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { isNumber } from '../../utils';
import { roundToRelativeScale } from '../../utils/number';
import styles from './ChartTooltip.module.css';
const ChartTooltip = ({ valuesDisplay, dateString }) => {
    return (_jsxs("div", Object.assign({ className: styles.tooltipRoot }, { children: [_jsx("div", Object.assign({ className: styles.tooltipDate }, { children: dateString }), void 0), valuesDisplay.map((entry, index) => {
                const { title, value, color } = entry;
                let processedValue = value;
                if (isNumber(+value)) {
                    processedValue = roundToRelativeScale(+value);
                }
                return (_jsxs("div", Object.assign({ className: styles.tooltipEntry }, { children: [title && _jsx("div", Object.assign({ className: styles.tooltipTitle }, { children: title }), void 0), _jsx("div", Object.assign({ className: styles.tooltipMainText, style: {
                                color,
                            } }, { children: processedValue }), void 0)] }), `tooltipEntry${index}${title}`));
            })] }), void 0));
};
export default ChartTooltip;
